import React from 'react';
import classNames from 'classnames';

import { useIntl } from '../../util/reactIntl';

import css from './HelpText.module.css';

// Matches translation ids like "whatsapp.help": dot-separated segments with
// a letter on both sides of each dot, and no spaces.
const TRANSLATION_ID_REGEX = /^[A-Za-z][A-Za-z0-9]*(\.[A-Za-z][A-Za-z0-9]*)+$/;

/**
 * This component can be used to show help text below form
 * input fields. It renders the given text string if present.
 * If the given text looks like a translation id (e.g. "whatsapp.help"),
 * it is resolved via intl instead of being rendered as-is.
 *
 * @component
 * @param {Object} props
 * @param {string} [props.rootClassName] - Custom class that overrides the default class for the root element
 * @param {string} [props.className] - Custom class that extends the default class for the root element
 * @param {string} [props.helpText] - The help text to display, or a translation id
 * @returns {JSX.Element|null} Help text component
 */
const HelpText = props => {
  const intl = useIntl();
  const { rootClassName, className, helpText } = props;
  const classes = classNames(rootClassName || css.root, className);
  const isTranslationId =
    typeof helpText === 'string' && TRANSLATION_ID_REGEX.test(helpText.trim());
  const content = isTranslationId ? intl.formatMessage({ id: helpText }) : helpText;

  return content ? (
    <p className={classes}>
      <span>{content}</span>
    </p>
  ) : null;
};

export default HelpText;
